module.exports = __webpack_public_path__ + "static/img/c2e813bc2d5840c695cb99b03ee0344e.d440449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/word/c2e813bc2d5840c695cb99b03ee0344e.jpg
// module id = CVC5
// module chunks = 1